import { render, staticRenderFns } from "./RequestConfirm.vue?vue&type=template&id=6bd0f494&"
import script from "./RequestConfirm.vue?vue&type=script&lang=js&"
export * from "./RequestConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports